import { atom } from 'jotai';

export const upgradePlanAtom = atom({
  isModalActive: false,
});
